import { render, staticRenderFns } from "./cirugias.vue?vue&type=template&id=676b3526&"
import script from "./cirugias.vue?vue&type=script&lang=js&"
export * from "./cirugias.vue?vue&type=script&lang=js&"
import style0 from "./cirugias.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports